export const CreateGenericAccountFormKey = {
  genericAccountName: "genericAccountName",
  purpose: "purpose",
  clientId: "clientId",
  clientName: "clientName",
  genericRegistrationCode: "genericRegistrationCode",
  startDate: "startDate",
  expirationDate: "expirationDate",
  status: "status",
  numberOfAccounts: "numberOfAccounts",
  programDuration: "programDuration",
  requestedBy: "requestedBy",
  requestedByUserId: "requestedByUserId",
  nextView: "nextView",
  country: "country",
  deliveryOffice: "deliveryOffice",
  nextProgramClass: "nextProgramClass",
  features: "features",
  featuresUniqueId: "featuresUniqueId",
  startDateWithoutFormatted: "startDateWithoutFormatted",
  expirationDateWithoutFormatted: "expirationDateWithoutFormatted",
} as const;

export interface FeaturesCheckBoxes {
  id: string;
  name: string;
  type: string;
  siteCoreKey: string;
  isChecked: boolean;
  sectionId: string;
  sectionTitle: string;
  featuresUniqueId: string;
}
